module.exports = __webpack_public_path__ + "static/media/check-round-icon.ba237d30.svg";